import React from 'react';

import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!


import Header from '../../Components/Header';

import Sidebar from '../../Components/Sidebar';

import PageHeader from '../../Components/PageHeader';

import Table from '../../Components/Table/Table';

import axios from 'axios';

export default function Calendar() {
  // const [wineVarietiesTable, setWineVarietiesTable] = React.useState(null);
  // // ...
  // React.useEffect(() => {
  //   axios.get(`${process.env.REACT_APP_API_URL}/wineVarieties`).then((response) => {
  //     setWineVarietiesTable(response.data);  
  //   });  
  // }, []);
  // // ...
  // const columns = React.useMemo(
  //   () => [
  //     {
  //       Header: 'Wine Variety',
  //       accessor: 'title',
  //     },
  //     {
  //       Header: 'Actions',
  //       accessor: 'id',

  //       Cell: (row: any) => {
  //         const editItem = (value: any) => {
  //                window.location.href = `/wine-varieties/edit/${row.value}`
  //         };
  //         const deleteItem = () => {
  //           axios.delete(`${process.env.REACT_APP_API_URL}/wineVarieties/${row.value}/`).then((res) => {
  //             if (res.data) {
  //               window.location.href = '/wine-varieties';
  //             }
  //           });
  //         };
  // return (
  // <div>

  //   <button
  //     onClick={editItem}
  //     className="bg-dark-1 hover:bg-dark-2 text-white font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded mr-4"
  //   >
  //     Edit
  //   </button>
  //   <button
  //     onClick={deleteItem}
  //     className="bg-dark-1 hover:bg-dark-2 text-white font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded mr-4"
  //   >
  //     Delete
  //   </button>
  // </div>
  //         );
  //       },
  //     },
  //   ],
  //   [],
  // );
  const [winesTable, setWinesTable] = React.useState(false);
  // ...
  React.useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/wines`)
      .then((response) => {

        const datas = response.data.map((cada) => {
          console.log(cada)
          return ({ title: cada.nome, date: cada.prontoParaBeber, url: `${window.location.origin}/wines/edit/${cada.id}`})
        })
        console.log(datas)
        setWinesTable(datas);
      });



  }, []);


  // ...
  return (
    <div className="flex">
      <Sidebar />
      <div className="content">
        <Header />
        <PageHeader
          title="Calendar"
        />
        <div className="grid grid-cols-12 gap-5 mt-5">

          <div className="col-span-12 xl:col-span-8 2xl:col-span-9">
            <div className="box p-5">

              <FullCalendar
                plugins={[dayGridPlugin]}
                initialView="dayGridMonth"
                weekends={true}
                // events={[{ title: 'event 1', date: '2021-12-12', url: 'http://google.com/' }]}
                 events={winesTable}
              />

            </div>
          </div>

        </div>


      </div>
    </div>
  );
}
// (winesTable.map(cada => {
                  //   console.log(cada)
                  //   return ({ title: 'event 1', date: '2021-12-12', url: 'http://google.com/' })
                  // }))
